import i18next, { type ReactOptions } from 'i18next';
import { initReactI18next, useTranslation as useTranslationI18next } from 'react-i18next';
import { useEffect, useState } from 'react';
import LanguageDetector from 'i18next-browser-languagedetector';
import { useParams } from 'next/navigation';

import { publicConfig } from '../utils/config';
import dayjs from '../utils/dayjs';

import { getOptions, init } from './index';

const { IS_SERVER_SIDE, LANGUAGES } = publicConfig();

const options = getOptions();

void init(i18next.use(initReactI18next).use(LanguageDetector), {
  lng: undefined,
  supportedLngs: LANGUAGES,
  detection: {
    order: ['cookie', 'path', 'htmlTag', 'navigator'],
    caches: ['cookie'],
    cookieOptions: { path: '/', expires: dayjs().add(1, 'year').toDate() },
  },
  preload: LANGUAGES,
});

export function useTranslation(o?: ReactOptions) {
  const res = useTranslationI18next(options.defaultNS, o);
  const { lng: lngParam } = useParams();
  const lng = typeof lngParam === 'string' ? lngParam : options.fallbackLng;

  const { i18n } = res;

  if (IS_SERVER_SIDE && lng && i18n.resolvedLanguage !== lng) {
    void i18n.changeLanguage(lng);
  } else {
    /* eslint-disable react-hooks/rules-of-hooks */
    const [activeLng, setActiveLng] = useState(i18n.resolvedLanguage);

    useEffect(() => {
      if (activeLng === i18n.resolvedLanguage) return;
      setActiveLng(i18n.resolvedLanguage);
    }, [activeLng, i18n.resolvedLanguage]);

    useEffect(() => {
      if (!lng || i18n.resolvedLanguage === lng) return;
      void i18n.changeLanguage(lng);
    }, [lng, i18n]);
    /* eslint-enable react-hooks/rules-of-hooks */
  }
  return { ...res, language: lng };
}
